<template>
<div class="mt-4 prose prose-sm prose-blue">

  <button type="button" @click="back" class="flex items-center space-x-0.5 text-gray-600">
    <ChevronLeftIcon class="w-5 h-5 text-gray-500" />
    <span>Back</span>
  </button>
  <p>
    We have partnered with Checks Direct to be able to supply you with an Enhanced DBS certificate.
    The certificate will be delivered and belong to you, which means you can also use it outside of The Tutor Index in a variety of other situations, such as employment or volunteering.
  </p>
  <p>
    The DBS application costs <strong>£75</strong>, payable after you have provided your details, before submission to the DBS service.
  </p>
  <div class="px-4 pt-4 pb-5 bg-blue-100 rounded-md">
    <h3 class="mt-0 font-semibold text-blue-900">
      Pst! Have you checked out The Tutor Index Plus?
    </h3>
    <p>
      The Tutor Index Plus includes a FREE Enhanced DBS Check when starting an annual subscription, in addition to a range of other great perks and exclusive features that improve your experience with The Tutor Index.
    </p>
    <TailwindButton @click="$router.push('Subscription')">Subscribe Today</TailwindButton>
  </div>
  <p>
    Once your DBS certificate has been produced, you will be automatically submitted to our DBS Check service.
    Please note, you will still need to meet our full list of <a @click="showRequirements" class="cursor-pointer">requirements</a> in order to pass our DBS Check, which is not guaranteed with a new DBS certificate alone.
  </p>

  <h3>
    Start Application
  </h3>
  <p class="mb-1">
    You will be redirected to ChecksDirect.co.uk to begin the application process.
    When prompted, please use the following organisation details:
  </p>
  <table class="mt-0 w-auto text-sm">
    <tr>
      <td>PIN Code</td>
      <td class="font-bold">13532</td>
    </tr>
    <tr>
      <td class="pr-2">Passphrase</td>
      <td class="font-bold">THTUIND</td>
    </tr>
  </table>

  <TailwindButton
    @click="startApplication"
  >
    Start Application
  </TailwindButton>

  <p>
    If you need any help with your application, please get in touch at <a href="mailto:support@thetutorindex.com">support@thetutorindex.com</a> and we will be happy to assist.
  </p>

</div>
</template>

<script>
import { ChevronLeftIcon } from '@vue-hero-icons/solid'
import TailwindButton from '../TailwindButton.vue'

export default {
  components: {
    ChevronLeftIcon,
    TailwindButton,
  },
  methods: {
    back() { this.$emit('back') },
    showRequirements() { this.$emit('showRequirements') },
    startApplication() {
      window.open('https://portal.checksdirect.co.uk/registration.php', 'ChecksDirect')
    },
  }
}
</script>

<style>

</style>